// extracted by mini-css-extract-plugin
export default {"body":"ownerDetailsModal_body__8mOWe"};